(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfGuardMin', function() {
    return {
      require: 'ngModel',
      link: (function(_this) {
        return function(scope, element, attrs, ngModel) {
          return element.on('blur', function(e) {
            if (Number(element.val()) < Number(attrs.mfGuardMin)) {
              element.val(null);
              return ngModel.$setViewValue(null);
            }
          });
        };
      })(this)
    };
  });

}).call(this);
